const API_SERVICE = 'https://server1-docs.herokuapp.com';
//const API_SERVICE = 'http://localhost:5000';
const SECRET_KEY = "7BA7A185C3B21C5542B884CC28EF1";

export {
    API_SERVICE,
    SECRET_KEY
}
